export default object => ({
  id: object.id,
  question: object.question,
  thanksText: object.thanksText,
  endDate: object.endDate,
  color: object.color,
  options: object.options,
});
